var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-pull-refresh',{attrs:{"value":_vm.value},on:{"input":_vm.onInput,"refresh":_vm.onRefresh}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }